/* eslint-disable camelcase */
export interface IAtrybutyMulti {
  AtrybutCharakterystyka?: string[];
  AtrybutPokoj?: string[];
  AtrybutUdogodnienia_AtrybutPolozenie?: string[];
  AtrybutWymaganeDokumenty?: string[];
  Miasta?: string[];
  Promocja?: string[];
  Sezon?: string[];
  StandardHotelu?: string[];
  Wyzywienia?: string[];
  Lokalizacje_HoteloProdukt?: string[];
  TypyWyjazdu?: string[];
  DataWylotu?: string[];
}

export interface IAtrybutySingle {
  Cena?: string[];
  DlugoscPobytu?: string[];
  OcenaKlientow?: string[];
  TypTransportu?: string[];
  TerminWyjazdu?: string[];
}

export interface ISzukajPayload {
  AtrybutyMulti?: IAtrybutyMulti;
  AtrybutySingle?: IAtrybutySingle;
  DatyUrodzenia?: string[];
  LiczbaPokoi?: Number;
  Sortowanie?: string;
}

export enum EAtrybutyMulti {
  atrybutCharakterystyka = 'AtrybutCharakterystyka',
  atrybutPokoj = 'AtrybutPokoj',
  atrybutUdogodnienia_AtrybutPolozenie = 'AtrybutUdogodnienia_AtrybutPolozenie',
  atrybutWymaganeDokumenty = 'AtrybutWymaganeDokumenty',
  lokalizacje_HoteloProdukt = 'Lokalizacje_HoteloProdukt',
  miasta = 'Miasta',
  promocja = 'Promocja',
  sezon = 'Sezon',
  standardHotelu = 'StandardHotelu',
  wyzywienia = 'Wyzywienia',
  atrybutTematyka = 'AtrybutTematyka',
  typyWyjazdu = 'TypyWyjazdu',
}

export enum EAtrybutySingle {
  cena = 'Cena',
  dlugoscPobytu = 'DlugoscPobytu',
  ocenaKlientow = 'OcenaKlientow',
  typTransportu = 'TypTransportu',
  terminWyjazdu = 'TerminWyjazdu',
}

export enum EOtherAttributes {
  datyUrodzenia = 'DatyUrodzenia',
  liczbaPokoi = 'LiczbaPokoi',
  sortowanie = 'Sortowanie',
  widok = 'Widok',
}

export enum keysMap {
  panstwa = 'lokalizacje_HoteloProdukt',
  regiony = 'lokalizacje_HoteloProdukt',
  wiek = 'datyUrodzenia',
  // miastaWyjazdu = 'miasta',
  // iatyWyjazdu = 'miasta',
  // typyTransportu = "typTransportu",
  wyzywienie = 'wyzywienia',
  tematyka = 'atrybutTematyka',
  typyWyjazdu = 'typyWyjazdu',
}
